/**
 * @file Exports the public API defined by this module.
 */
import { Provider } from 'injection-js';
import { ModuleWithProviders, OnDestroy } from './angular-stubs';

export type {
  Provider
};

  export {
    Inject,
    Injectable,
    InjectionToken,
    Injector,
    Optional,
    ReflectiveInjector,
    SkipSelf
  } from 'injection-js';
  export type {
    ModuleWithProviders,
    OnDestroy
  };

  export {
    NgModule
  } from './angular-stubs';

